var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftwhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0625 6.5627H2.94375L6.34688 2.4752C6.50601 2.28374 6.58256 2.03692 6.55971 1.78902C6.53685 1.54112 6.41645 1.31245 6.225 1.15332C6.03355 0.994193 5.78672 0.917634 5.53882 0.94049C5.29092 0.963346 5.06225 1.08374 4.90312 1.2752L0.215625 6.9002C0.184088 6.94494 0.155887 6.99194 0.13125 7.04082C0.13125 7.0877 0.13125 7.11582 0.0656252 7.1627C0.0231316 7.27019 0.000882301 7.38461 0 7.5002C0.000882301 7.61578 0.0231316 7.7302 0.0656252 7.8377C0.0656252 7.88457 0.0656249 7.9127 0.13125 7.95957C0.155887 8.00845 0.184088 8.05546 0.215625 8.1002L4.90312 13.7252C4.99127 13.831 5.10165 13.9161 5.22642 13.9745C5.35118 14.0328 5.48727 14.0629 5.625 14.0627C5.84405 14.0631 6.05633 13.9868 6.225 13.8471C6.31993 13.7684 6.3984 13.6717 6.45592 13.5626C6.51344 13.4536 6.54887 13.3342 6.56019 13.2114C6.57151 13.0886 6.5585 12.9648 6.52189 12.8471C6.48529 12.7293 6.42582 12.6199 6.34688 12.5252L2.94375 8.4377H14.0625C14.3111 8.4377 14.5496 8.33893 14.7254 8.16311C14.9012 7.98729 15 7.74884 15 7.5002C15 7.25156 14.9012 7.0131 14.7254 6.83728C14.5496 6.66147 14.3111 6.5627 14.0625 6.5627Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftwhite);
export default __webpack_public_path__ + "static/media/Left white.1e2167bc6b5ce26d0d30839036612b85.svg";
export { ForwardRef as ReactComponent };